import { isStaging } from '@/utils/Location';

const mockedCampaignUnitProd = [
  {
    id: 'Hvfg11xT7T4FxWRuzuWZ',
    campaignId: 'haG9xgq3BXKafAwAzTwQ',
    slug: null,
    type: 'coupon',
    title: 'Play the Quiz',
    description: 'Play the Quiz',
    terms: null,
    itemType: 'medium',
    expireAt: '2027-01-11T09:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-09T21:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Ffamily-homepage-games.production.mcd-sa.platform-tbwa-x.com%2Fquiz',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 10,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/Quiz-1755094639543.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#863399',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/Quiz-1755094635930.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'لعبة الإختبار',
        en: 'Play the Quiz'
      },
      description: {
        ar: 'جاهز تعيش المتعة',
        en: 'Just ask!'
      }
    }
  },
  {
    id: '5D8jCTGMSxi1UD2FXsyy',
    campaignId: 'haG9xgq3BXKafAwAzTwQ',
    slug: null,
    type: 'coupon',
    title: 'Fanshop',
    description: 'Exclusive merch',
    terms: null,
    itemType: 'medium',
    expireAt: '2027-01-11T09:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-09T21:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Ffanshop.production.mcd-sa.platform-tbwa-x.com%2F',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 19,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/Gift_Card_2.1-1755094568166.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#DB0007',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/Property 1=Variant2-1755250317522.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'متجر فان شوب',
        en: 'Family Fanshop'
      },
      description: {
        ar: 'منتجات حصرية',
        en: 'Exclusive merch'
      }
    }
  },
  {
    id: '85TCgm8ggu7RK62wPW7g',
    campaignId: 'haG9xgq3BXKafAwAzTwQ',
    slug: null,
    type: 'coupon',
    title: 'Deals for the family',
    description: 'Deals for the family',
    terms: null,
    itemType: 'medium',
    expireAt: '2027-01-11T09:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-13T21:00:00.000Z',
    ctaTitle: '',
    ctaUrl: 'gmalite://gmalite-deals',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 30,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/mym_coins (1)-1755178638341.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#F5BE44',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/mym_coins (1)-1755178634761.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'عروض حصرية لك',
        en: 'Deals for you'
      },
      description: {
        ar: 'استمتع بألذ العروض مع العائلة',
        en: 'Enjoy with the family'
      }
    }
  },
  {
    id: '5o24J30Vjbdj3HXu2QV6',
    campaignId: 'haG9xgq3BXKafAwAzTwQ',
    slug: null,
    type: 'coupon',
    title: 'Table Challenge',
    description: 'Table Challenge',
    terms: null,
    itemType: 'medium',
    expireAt: '2025-12-31T21:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-16T21:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Ftable-challenge.production.mcd-sa.platform-tbwa-x.com%2F',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 40,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/Table_challenge-1755603143890-1755701312701.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#2EBBC4',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/Table_challenge-1755603143890-1755701308784.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'تحدي الطاولة',
        en: 'Table Challenge'
      },
      description: {
        ar: 'هل بتكون الفايز؟',
        en: 'Will you be the winner?'
      }
    }
  },
  {
    id: 'G6Rn2ZUoduFuIA814BpN',
    campaignId: 'haG9xgq3BXKafAwAzTwQ',
    slug: null,
    type: 'coupon',
    title: 'Kids party finder',
    description: 'The best kids parties',
    terms: null,
    itemType: 'medium',
    expireAt: '2027-01-11T11:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-03T22:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Fkids-party.production.mcd-sa.platform-tbwa-x.com%2F',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 50,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/algemeen - balloon-1755094351656.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#2EBBC4',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-prod/campaign-units/algemeen - balloon-1755094348131.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'احجز حفلات أطفالك',
        en: 'Kids party finder'
      },
      description: {
        ar: 'أروع حفلات تسعد الأطفال',
        en: 'The best kids parties'
      }
    }
  }
];

const mockedCampaignUnitStaging = [
  {
    id: 'wjCyfLiXRlg5XGQDDcNO',
    campaignId: 'tVmvyxAIf5IVXx5sUFwo',
    slug: null,
    type: 'coupon',
    title: 'Play the Quiz',
    description: 'Play the Quiz',
    terms: null,
    itemType: 'small',
    expireAt: '2026-01-15T23:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-09T22:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Ffamily-homepage-games.staging.mcd-sa.platform-tbwa-x.com%2Fquiz%3Ffullscreen%3Dtrue%26appOrientation%3Dlandscape',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 10,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/Quiz-1755081098275.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#863399',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/Quiz-1755081094716.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'لعبة الإختبار',
        en: 'Play the Quiz'
      },
      description: {
        ar: 'جاهز تعيش المتعة',
        en: 'Just ask!'
      }
    }
  },
  {
    id: 'dITatxDh4NJ1EOfOcy0Y',
    campaignId: 'tVmvyxAIf5IVXx5sUFwo',
    slug: null,
    type: 'coupon',
    title: 'Fanshop',
    description: 'Exclusive merch',
    terms: null,
    itemType: 'medium',
    expireAt: '2026-02-27T23:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-09T22:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Ffanshop.staging.mcd-sa.platform-tbwa-x.com%2F',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 20,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/card (1)-1755081046824.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#DB0007',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/card (1)-1755081026334.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'متجر فان شوب',
        en: 'Family Fanshop'
      },
      description: {
        ar: 'منتجات حصرية',
        en: 'Exclusive merch'
      }
    }
  },
  {
    id: 'XlCkMjjRqPXWZysy62Sf',
    campaignId: 'tVmvyxAIf5IVXx5sUFwo',
    slug: null,
    type: 'coupon',
    title: 'Deals for the family',
    description: 'Deals for the family',
    terms: null,
    itemType: 'medium',
    expireAt: '2025-08-31T09:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-18T21:00:00.000Z',
    ctaTitle: '',
    ctaUrl: 'gmalite://gmalite-deals',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 30,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/mym_coins (1)-1755604421399.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#F5BE44',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/mym_coins (1)-1755604418053.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'عروض حصرية لك',
        en: 'Deals for you'
      },
      description: {
        ar: 'استمتع بألذ العروض مع العائلة',
        en: 'Enjoy with the family'
      }
    }
  },
  {
    id: 'pbc0qrJ7D2D4vtS00kZQ',
    campaignId: 'tVmvyxAIf5IVXx5sUFwo',
    slug: null,
    type: 'coupon',
    title: 'Table Challenge',
    description: 'Table Challenge',
    terms: null,
    itemType: 'medium',
    expireAt: '2025-12-31T21:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-09T21:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Ftable-challenge.staging.mcd-sa.platform-tbwa-x.com%2F',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 40,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/Table_challenge-1755603147819.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#2EBBC4',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/Table_challenge-1755603143890.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'تحدي الطاولة',
        en: 'Table Challenge'
      },
      description: {
        ar: 'هل بتكون الفايز؟',
        en: 'Will you be the winner?'
      }
    }
  },
  {
    id: 'dXENht1y3fKRJ2yjG83w',
    campaignId: 'tVmvyxAIf5IVXx5sUFwo',
    slug: null,
    type: 'coupon',
    title: 'Kids party finder',
    description: 'The best kids parties',
    terms: null,
    itemType: 'large',
    expireAt: '2026-01-15T23:00:00.000Z',
    highlight: false,
    style: '',
    availableAt: '2025-08-03T22:00:00.000Z',
    ctaTitle: '',
    ctaUrl:
      'gmalite://gmalite-smartweb?weburl=https%3A%2F%2Fkids-party.staging.mcd-sa.platform-tbwa-x.com%2F',
    ctaButtonColor: '',
    ctaButtonTextColor: '',
    priority: 50,
    discountcodeFormat: 'noCode',
    countdown: false,
    label: '',
    detailsTitle: '',
    detailsDescription: '',
    imageCardSmallUrl: null,
    imageCardMediumUrl: null,
    imageCardLargeUrl: null,
    imageCardHorizontalUrl: null,
    detailsImageUrl:
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/algemeen - balloon-1755080857315.png',
    ctaSoldoutTitle: '',
    ctaSoldoutURL: '',
    detailsCTA: '',
    bgColor: '#2EBBC4',
    bgImageUrls: [],
    imageUrls: [
      'https://storage.googleapis.com/media-mcd-sa-familymode-staging/campaign-units/algemeen - balloon-1755080958061.png'
    ],
    loginRequired: false,
    publicData: {},
    translations: {
      title: {
        ar: 'احجز حفلات أطفالك',
        en: 'Kids party finder'
      },
      description: {
        ar: 'أروع حفلات تسعد الأطفال',
        en: 'The best kids parties'
      }
    }
  }
];

export const mockedCampaignUnit = isStaging
  ? mockedCampaignUnitStaging
  : mockedCampaignUnitProd;
